import {createContext, Dispatch, FC, SetStateAction, useContext, useState} from 'react'
import {WithChildren} from '../../../_metronic/helpers'
import {IRouteSenderRoles} from './_model'

export type Sender = {
  id: number
  value: string
}

type RouteManagementContextType = {
  searchTerm: string
  setSearchTerm: Dispatch<SetStateAction<string>>
  showSenderModal: boolean
  setShowSenderModal: Dispatch<SetStateAction<boolean>>
  senderSelectType: string
  setSenderSelectType: Dispatch<SetStateAction<string>>
  sourceSenderIds: Sender[] | null
  setSourceSenderIds: Dispatch<SetStateAction<Sender[] | null>>
  destinationSenderIds: Sender[] | null
  setDestinationSenderIds: Dispatch<SetStateAction<Sender[] | null>>
  routeSenderIds: Sender[] | null
  setRouteSenderIds: Dispatch<SetStateAction<Sender[] | null>>
  selectRouteSenderRole: IRouteSenderRoles | null
  setSelectRouteSenderRole: Dispatch<SetStateAction<IRouteSenderRoles | null>>
}

const RouteManagementContext = createContext<RouteManagementContextType | null>(null)

export const RouteManagementProvider: FC<WithChildren> = ({children}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [showSenderModal, setShowSenderModal] = useState(false)
  const [sourceSenderIds, setSourceSenderIds] = useState<Sender[] | null>(null)
  const [destinationSenderIds, setDestinationSenderIds] = useState<Sender[] | null>(null)
  const [routeSenderIds, setRouteSenderIds] = useState<Sender[] | null>(null)
  const [senderSelectType, setSenderSelectType] = useState('')
  const [selectRouteSenderRole, setSelectRouteSenderRole] = useState<IRouteSenderRoles | null>(null)

  return (
    <RouteManagementContext.Provider
      value={{
        showSenderModal,
        searchTerm,
        sourceSenderIds,
        destinationSenderIds,
        senderSelectType,
        routeSenderIds,
        selectRouteSenderRole,
        setDestinationSenderIds,
        setSenderSelectType,
        setSourceSenderIds,
        setShowSenderModal,
        setSearchTerm,
        setRouteSenderIds,
        setSelectRouteSenderRole,
      }}
    >
      {children}
    </RouteManagementContext.Provider>
  )
}

export const useRouteManagement = () => {
  const context = useContext(RouteManagementContext)

  if (!context) {
    throw Error('useRouteManagement must be in RouteManagementProvider')
  }

  return context
}
